export default {
    "types": {
        "1": {
            "showName": "Создана"
        },
        "50": {
            "showName": "В работе"
        },
        "200": {
            "showName": "Завершена"
        }
    }
}